module.exports = __webpack_public_path__ + "img/patent_image4.1979ea06.png";